import { lazyLoad } from 'utils/loadable';

export const LandingPage = lazyLoad(
  () => import('app/components/pages/LandingPage/index'),
  (module) => module.LandingPage,
);
